import { Callout, Control, Controller, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { PermissionsField as PermissionsFieldCommon } from 'src/components/common/form/fields/permissions';
import { ResourceForm } from '../types';

type PermissionFieldProps = {
  control: Control<ResourceForm>;
};

export const PermissionField = ({ control }: PermissionFieldProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="permissionId"
      control={control}
      rules={{ required: false }}
      render={({ field }) => (
        <div>
          <Typography className="mb-2" variant="subtitle1">
            {t('common.permission')}
          </Typography>
          <PermissionsFieldCommon field={field} />

          {!field.value && (
            <Callout severity="warning" className="mt-2">
              {t('resources.form.public-alert')}
            </Callout>
          )}
        </div>
      )}
    />
  );
};
